/* bacalalo-island-shipping.js
 * Cambia el mensaje de "envío gratis" SOLO para visitantes de
 * Canarias / Baleares / Ceuta / Melilla. Península: no toca nada.
 * 100% defensivo: si la geolocalización falla, no hace nada (fallback península).
 * Detección por IP (ipapi.co, fallback ipwho.is); resultado cacheado en sessionStorage.
 */
(function () {
  "use strict";
  var ISLAND_MSG = "Envío especial 24-48h a Canarias, Baleares, Ceuta y Melilla · tarifa según destino";
  var ISLAND_CODES = ["CN", "IB", "CE", "ML", "GC", "TF", "PM"]; // ISO región/provincia ES
  var ISLAND_RE = /canaria|canary|balear|baleari|ceuta|melilla|palmas|tenerife|mallorca|menorca|ibiza|formentera/i;
  var FREE_RE = /gratis|free shipping|env[íi]o gratis|\b99\b/i;

  function s(v) { return (v == null ? "" : "" + v); }

  function isIsland(geo) {
    if (!geo) return false;
    var cc = s(geo.country_code || geo.countryCode || geo.country).toUpperCase();
    if (cc !== "ES") return false;
    var rc = s(geo.region_code || geo.regionCode || geo.region_iso).toUpperCase();
    if (ISLAND_CODES.indexOf(rc) !== -1) return true;
    var rn = s(geo.region) + " " + s(geo.region_name) + " " + s(geo.city);
    return ISLAND_RE.test(rn);
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function swapAnnouncements() {
    try {
      var anns = document.querySelectorAll(".announcement, .announcement-bar__slider .announcement");
      for (var i = 0; i < anns.length; i++) {
        var el = anns[i];
        if (el.getAttribute("data-bcl-island")) continue;
        if (FREE_RE.test(el.textContent || "")) {
          var a = el.querySelector("a");
          if (a) a.textContent = ISLAND_MSG; else el.textContent = ISLAND_MSG;
          el.setAttribute("data-bcl-island", "1");
        }
      }
    } catch (e) {}
  }

  function swapCartNotice() {
    try {
      if (window.KROWN && window.KROWN.settings && window.KROWN.settings.locales) {
        var L = window.KROWN.settings.locales;
        if ("shipping_notice_remaining_to_free" in L) L.shipping_notice_remaining_to_free = ISLAND_MSG;
        if ("shipping_notice_eligible_for_free" in L) L.shipping_notice_eligible_for_free = ISLAND_MSG;
      }
      var notes = document.querySelectorAll("shipping-notice");
      for (var i = 0; i < notes.length; i++) {
        notes[i].textContent = ISLAND_MSG;
        notes[i].setAttribute("data-bcl-island", "1");
      }
    } catch (e) {}
  }

  function applyIslandCopy() {
    try { document.documentElement.classList.add("bcl-island"); } catch (e) {}
    swapAnnouncements();
    swapCartNotice();
  }

  function observe() {
    try {
      var obs = new MutationObserver(function () { swapAnnouncements(); swapCartNotice(); });
      ready(function () { if (document.body) obs.observe(document.body, { childList: true, subtree: true }); });
    } catch (e) {}
  }

  function activateIsland() { ready(applyIslandCopy); observe(); }

  function fetchGeo(url, onok, onfail) {
    try {
      var ctrl = new AbortController();
      var t = setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 2500);
      fetch(url, { signal: ctrl.signal, headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (j) { clearTimeout(t); if (j && (j.country_code || j.country)) onok(j); else onfail(); })
        .catch(function () { clearTimeout(t); onfail(); });
    } catch (e) { onfail(); }
  }

  function run() {
    var cached = null;
    try { cached = sessionStorage.getItem("bcl_geo_island"); } catch (e) {}
    if (cached === "1") { activateIsland(); return; }
    if (cached === "0") { return; } // península conocida → no hacer nada
    var done = false;
    function decide(geo) {
      if (done) return; done = true;
      var island = false;
      try { island = isIsland(geo); } catch (e) {}
      try { sessionStorage.setItem("bcl_geo_island", island ? "1" : "0"); } catch (e) {}
      if (island) activateIsland();
    }
    fetchGeo("https://ipapi.co/json/", decide, function () {
      fetchGeo("https://ipwho.is/", decide, function () { /* silencio → península */ });
    });
  }

  run();
})();
